<section>
    <div class="card" *ngIf="data" [ngClass]="{ 'card-pending': pending }">
        <div>
            <div class="image-wrapper">
                <app-product-image
                    [image]="{ src: data.imageUrl, name: data.productName }"
                    [width]="80"
                    [height]="80"
                    wrapperWidth="80px"
                    wrapperHeight="80px"
                    preset="94|94"
                    preset2x="150|150"
                ></app-product-image>
            </div>
        </div>
        <div class="description">
            <p class="detail">{{ data.brand }}</p>
            <h5 class="product-name display-5">
                {{ data.productName }}
            </h5>
            <p class="display-label">
                {{ 'basket.line.unitPrice' | translateSafe: { unitPrice: data.unitPrice } }}
            </p>
        </div>
        <div class="quantity-and-price">
            <div class="price">
                <div class="product-prices-wrapper">
                    <table class="product-prices-table">
                        <ng-container *ngIf="data.priceAmountBeforeDiscount === data.priceAmount">
                            <tr>
                                <td class="price-description price-description-large"></td>
                                <td class="price-value price-value-large">{{ data.priceAmount }}</td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="data.priceAmountBeforeDiscount !== data.priceAmount">
                            <tr>
                                <td class="price-description price-description-large">
                                    {{ 'basket.line.priceAfterDiscount' | translateSafe }}
                                </td>
                                <td class="price-value price-value-large">{{ data.priceAmount }}</td>
                            </tr>
                            <tr>
                                <td class="price-description discount">{{ 'basket.line.discount' | translateSafe }}</td>
                                <td class="price-value discount">{{ data.discountAmount }}</td>
                            </tr>
                            <tr>
                                <td class="price-description price">{{ 'basket.line.price' | translateSafe }}</td>
                                <td class="price-value price kk-line-through">{{ data.priceAmountBeforeDiscount }}</td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
